import { Components, Theme } from '@mui/material/styles';

export const MuiPickersCalendarHeader: Components<Theme>['MuiPickersCalendarHeader'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginTop: theme.spacing(12),
      marginBottom: theme.spacing(4),
      paddingLeft: theme.spacing(24),
      paddingRight: theme.spacing(12),
      maxHeight: theme.spacing(40),
      minHeight: theme.spacing(40),
    }),
  },
};

export const MuiDateRangePickerDay: Components<Theme>['MuiDateRangePickerDay'] = {
  styleOverrides: {
    day: ({ theme }) => ({
      height: theme.spacing(36),
      width: theme.spacing(36),
    }),
  },
};

export const MuiDayCalendar: Components<Theme>['MuiDayCalendar'] = {
  styleOverrides: {
    weekDayLabel: ({ theme }) => ({
      margin: theme.spacing(0, 2),
      width: theme.spacing(36),
      height: theme.spacing(40),
    }),
    slideTransition: ({ theme }) => ({
      minWidth: theme.spacing(312),
      minHeight: theme.spacing(264),
    }),
    weekContainer: ({ theme }) => ({
      margin: theme.spacing(2, 0),
    }),
  },
};
